// Types mirroring backend/src/schemas/festival.py
// Decimals are serialized as numbers (via Decimal json_encoder); datetimes are ISO strings.

export type FestivalStatus = 'DRAFT' | 'PUBLISHED' | 'CANCELLED' | 'ARCHIVED';

export const FESTIVAL_STATUS_VALUES: FestivalStatus[] = [
  'DRAFT',
  'PUBLISHED',
  'CANCELLED',
  'ARCHIVED',
];

export interface Festival {
  id: string;
  slug: string;
  name: string;
  name_en: string | null;
  description: string | null;
  description_en: string | null;
  hero_image_url: string | null;
  venue_name: string | null;
  /** Nearest known city for routing. Backend requires it before PUBLISHED. */
  venue_city: string | null;
  venue_lat: number;
  venue_lng: number;
  geofence_radius_km: number;
  starts_at: string;
  ends_at: string;
  status: FestivalStatus;
  created_at: string;
  updated_at: string;
}

// Mirrors FestivalCreateRequest. Backend defaults status=DRAFT and radius=15.00,
// but we send them explicitly from the form so admins see what's going up.
export interface FestivalCreatePayload {
  slug: string;
  name: string;
  name_en?: string | null;
  description?: string | null;
  description_en?: string | null;
  hero_image_url?: string | null;
  venue_name?: string | null;
  venue_city?: string | null;
  venue_lat: number;
  venue_lng: number;
  geofence_radius_km: number;
  starts_at: string;
  ends_at: string;
  status: FestivalStatus;
}

// Mirrors FestivalUpdateRequest — all fields optional.
export type FestivalUpdatePayload = Partial<FestivalCreatePayload>;

export interface FestivalStatusUpdatePayload {
  status: FestivalStatus;
}
